/**
 * BackupContinuity.jsx — Subtab VIII
 */

import React from "react";
import { DiodeMirror } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function BackupContinuity() {
  return (
    <article>
      <SubtabHeading roman="VIII">Backup, Disaster Recovery, and Continuity</SubtabHeading>
      <DiodeMirror />
      <GapBlock>
        Backup-to-cloud is off the table in an air-gapped environment. Hardware
        failures, ransomware, and physical disasters still happen, and the
        firm has client deadlines.
      </GapBlock>
      <SolutionLead>
        Geographically redundant air-gapped infrastructure with diode-mediated
        replication.
      </SolutionLead>
      <Body>
        <P>
          Primary infrastructure is mirrored to a secondary air-gapped
          facility in a different geographic region. Replication flows through
          unidirectional gateways — Owl DualDiode or Waterfall Unidirectional
          Security Gateway — from primary to secondary. The secondary cannot
          transmit back to primary, preserving the air-gap property even
          during replication.
        </P>
        <P>
          Backup retention follows the 3-2-1-1-0 rule adapted for air-gap:
          three copies of data, on two different media types, with one offsite
          (the secondary facility), one immutable (WORM storage at the
          secondary), and zero verified errors (cryptographic verification of
          every backup).
        </P>
        <P>
          Recovery time objective (RTO) for matter-critical work is four
          hours; recovery point objective (RPO) is fifteen minutes for active
          matters. These numbers are achievable with the diode-replication
          architecture because the secondary site runs warm-standby, not cold
          backup.
        </P>
        <P>
          For ransomware specifically, the WORM-stored backups at the
          secondary site cannot be encrypted by an attacker who compromises
          the primary, because the diode prevents the attacker from reaching
          the secondary's storage layer at all. This is the architectural
          reason data diodes are now standard in critical infrastructure and
          increasingly in financial services.
        </P>
        <P>
          Tabletop exercises and full-scale failover tests are conducted
          quarterly, with the supervising attorney participating to verify
          legal-process continuity (active matter deadlines are met,
          court-imposed dates are not missed). This is borrowed directly from
          financial-services BCP practice required under Reg SCI and FFIEC
          guidance.
        </P>
      </Body>
    </article>
  );
}
